import { useEffect } from "react";
import L from "leaflet";

export default function ConsolLegend({ map, mapType }) {
  const bootsOnGroundHtml =
    `<div class="legendOrder legendMarker" title="Order location only, no indication of supplier user on site."></div>
    <div class="legendBootsOn legendMarker" title="Order location with at least one supplier user marked on site."></div>
    <div class="legendBootsOnStale legendMarker" title="Order location with at least one supplier user marked on site, but no recent updates for 1 hour or more."></div>
    <div class="legendClashOrder legendMarker" title="Location with multiple orders, no indication of supplier users on site."></div>
    <div class="legendClashBootsOn legendMarker" title="Location with multiple orders with at least one supplier user marked on site."></div>
    <div class="legendClassBootsOnStale legendMarker" title="Location with multiple orders with at least one supplier user marked on site, but no recent updates for 1 hour or more."></div>
    <div class="legendSummary" title="Summary of all orders in region with counts of orders in each category above (definite user on site, probable user on site, and order location only). Hovering over this icon shows the geographic bounds covered by the summary."></div>`;

  const orderHtml =
    `<div class="legendClassOrder legendMarker" title="Order location."></div>
    <div class="legendClassSupplierSelected legendMarker" title="Depot for a selected supplier."></div>
    <div class="legendClassSupplier legendMarker" title="Depot for an unselected candidate supplier."></div>`;

  useEffect(() => {

    if (map) {
	  if(mapType == 'boots' || mapType == 'supplierSelection') {
        const legend = L.control({ position: "bottomleft" });

		var innerHTML = bootsOnGroundHtml;
		if(mapType == 'supplierSelection') innerHTML = orderHtml;

        legend.onAdd = () => {
          var div = L.DomUtil.create("div", "mapLegend");
          div.innerHTML = innerHTML;
          return div;
        };

        legend.addTo(map);
      }
    }
    
  }, [map]);
  return null;
}
